module.exports = __webpack_public_path__ + "static/media/aphetor_logo.3117196e.png";